var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.settings.show_anouncemnt_banner)?_c('div',{attrs:{"id":"fixed_announcement_banner"}},[_vm._v(" "+_vm._s(_vm.settings.anouncemnt_banner_text)+" ")]):_vm._e(),(!_vm.settingsReady && !_vm.loading)?_c('NoSettings'):(!_vm.loading)?_c('transition',[_c('transition',{attrs:{"name":"slide-fade"}},[_c('router-view')],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }